import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { Filter } from "@/shared/lib/filter/filter";
import { FeatureAuthRule } from "../types/feature-auth-rule";
import { backendApi } from "../../api";

const featureAuthApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["AuthFeatureAuth"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      authFeatureAuthPut: build.mutation<FeatureAuthRule, PutRequest>({
        query: (request) => ({
          url: `auth/feature-auth`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: ["AuthFeatureAuth"],
      }),
      authFeatureAuthShow: build.query<FeatureAuthRule, ShowRequest>({
        query: (request) => ({
          url: `auth/feature-auth`,
          method: "GET",
          params: request,
        }),
        providesTags: ["AuthFeatureAuth"],
      }),
      authFeatureAuthList: build.query<List, ListRequest>({
        query: (request) => ({
          url: `auth/feature-auth/list`,
          method: "GET",
          params: { request: btoa(JSON.stringify(request)) },
        }),
        providesTags: ["AuthFeatureAuth"],
      }),
      authFeatureAuthCheck: build.query<CheckResponse, CheckRequest>({
        query: (request) => ({
          url: `auth/feature-auth/check`,
          method: "GET",
          params: request,
        }),
        providesTags: ["AuthFeatureAuth"],
      }),
      authFeatureAuthDelete: build.mutation<FeatureAuthRule, DeleteRequest>({
        query: (request) => ({
          url: `auth/feature-auth`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: ["AuthFeatureAuth"],
      }),
    }),
  });

export const {
  useAuthFeatureAuthPutMutation,
  useAuthFeatureAuthShowQuery,
  useAuthFeatureAuthListQuery,
  useAuthFeatureAuthCheckQuery,
  useAuthFeatureAuthDeleteMutation,
} = featureAuthApi;

export type PutRequest = FeatureAuthRule;

export type ShowRequest = {
  feature: string;
};

export type ListRequest = {
  feature?: Filter<string>;
  orderBy?: OrdrBy<"feature">[];
  limit?: number;
  offset?: number;
};

export type List = {
  items: FeatureAuthRule[];
  totalCount: number;
  limit: number;
  offset: number;
};

export type CheckRequest = {
  feature: string;
};

export type CheckResponse = {
  hasAccess: boolean;
};

export type DeleteRequest = {
  feature: string;
};
